export default __webpack_public_path__ + "static/media/ad_banner3.7eec0a71.png";